let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("35355")).then(() => parcelRequire('f87hJ'));